import { Product } from '@/api/_schemas/management'
import { FormUpdateProduct } from '@/app/panel/management/price-list/_schemas/update-product'

enum TabsOptions {
  product = 'product',
  combo = 'combo',
}

enum AccordionOptions {
  geral = 'geral',
  tax = 'tax',
  combo = 'combo',
}

type PriceListKeyItem = 'infinite' | 'configureInfinite'

type TaxKeyItem =
  | 'ncmList'
  | 'cfopList'
  | 'icmsOrigemList'
  | 'icmsSituacaoList'
  | 'icmsModalidadeList'
  | 'pisCofinsTipoList'
  | 'pisCofinsSituacaoList'

const stepErrors: Record<keyof FormUpdateProduct, AccordionOptions> = {
  tipo: AccordionOptions.geral,
  nome: AccordionOptions.geral,
  produto_pai: AccordionOptions.geral,
  produto_pai_nome: AccordionOptions.geral,
  vlr_custo: AccordionOptions.geral,
  tipo_valor: AccordionOptions.geral,
  situacao: AccordionOptions.geral,
  consumo: AccordionOptions.geral,
  permitir_observacao: AccordionOptions.geral,
  servico: AccordionOptions.geral,
  imagem: AccordionOptions.geral,
  cod_produto: AccordionOptions.tax,
  cod_externo: AccordionOptions.tax,
  unidade_medida: AccordionOptions.tax,
  grupo_tributario: AccordionOptions.tax,
  cfop: AccordionOptions.tax,
  ncm: AccordionOptions.tax,
  icms_situacao_tributaria: AccordionOptions.tax,
  icms_origem: AccordionOptions.tax,
  icms_aliquota: AccordionOptions.tax,
  icms_percentual_reducao_base_calculo: AccordionOptions.tax,
  icms_modalidade_base_calculo: AccordionOptions.tax,
  cest: AccordionOptions.tax,
  pis_situacao_tributaria: AccordionOptions.tax,
  pis_tipo_tributacao: AccordionOptions.tax,
  pis_aliquota_percentual: AccordionOptions.tax,
  cofins_situacao_tributaria: AccordionOptions.tax,
  cofins_tipo_tributacao: AccordionOptions.tax,
  cofins_aliquota_percentual: AccordionOptions.tax,
  tipo_ticket_combo: AccordionOptions.combo,
  produto_combo_list: AccordionOptions.combo,
}

type ComboProduct = NonNullable<Product['produto_combo_list']>[0]

export {
  TabsOptions,
  AccordionOptions,
  stepErrors,
  type PriceListKeyItem,
  type TaxKeyItem,
  type ComboProduct,
}
